import React, { useState } from 'react'
import { Box, Button, Fab, Modal, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CloseOutlined } from '@mui/icons-material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { FileUploader } from 'react-drag-drop-files'
import { RenderTooltip } from '../../../../components/utilities/RenderTooltip'
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined'

function ModalUpdateBatch({ showUpdateBatch, setShowUpdateBatch, updateBatch, batchId }) {
  const { t } = useTranslation(['common', 'messages'])
  const [file, setFile] = useState('')

  const handleModalClose = () => {
    setFile(null)
    setShowUpdateBatch(false)
  }

  const handleSubmit = async () => {
    updateBatch(file)
    setShowUpdateBatch(false)
  }

  const canSend = () => !file

  return (
    <Modal open={showUpdateBatch} onClose={() => handleModalClose()}>
      <Box className="modal">
        <Box className="modal-top">
          <Box className="modal-titles">
            <Typography variant="title">{t('common:BATCH_UPLOAD_CORRECTION_FILE')}</Typography>
          </Box>
          <Fab variant="close" onClick={() => handleModalClose()}>
            <CloseOutlined />
          </Fab>
        </Box>
        <Box className="modal-box-lists">
          <Box className="lists-box">
            <Typography variant="text2">{t('common:BATCH_ID')}</Typography>
            <Typography variant="body1">{batchId}</Typography>
          </Box>
          <Box className="lists-box">
            <Box className="batch-label">
              <Typography variant="title2">{t('common:BATCH_FILES_MODELS')}</Typography>
              <RenderTooltip title={t('common:BATCH_FILES_MODELS_TOOLTIP')} />
            </Box>
            <Box display="flex" flexDirection="row" justifyContent="space-evenly" gap="0.5rem">
              <Button
                variant="outlined"
                onClick={() =>
                  window.open(
                    'https://docs.google.com/spreadsheets/d/10LQy86ut4JJFA8MU99MgPSh9VkzHr9xvbQDYel-fO5Y/edit?usp=sharing',
                    '_blank',
                    'rel=noopener noreferrer',
                  )
                }
                startIcon={<InsertLinkOutlinedIcon />}
                sx={{ paddingInline: '10px' }}
              >
                {t('common:CONSUMER_BATCH')}
              </Button>
              <Button
                variant="outlined"
                onClick={() =>
                  window.open(
                    'https://docs.google.com/spreadsheets/d/1J30NNk64vxMLsrOBjdftZFeg4CDRyOVUPG34l1rTU0Q/edit?usp=sharing',
                    '_blank',
                    'rel=noopener noreferrer',
                  )
                }
                startIcon={<InsertLinkOutlinedIcon />}
                sx={{ paddingInline: '10px' }}
              >
                {t('common:BUSINESS_BATCH')}
              </Button>
              <Button
                variant="outlined"
                onClick={() =>
                  window.open(
                    'https://docs.google.com/spreadsheets/d/1hbXY0JEG7qM9YLONBGmmoU-W5g1Q0UFBrLhkNyXV_Sw/edit?usp=sharing',
                    '_blank',
                    'rel=noopener noreferrer',
                  )
                }
                startIcon={<InsertLinkOutlinedIcon />}
                sx={{ paddingInline: '10px' }}
              >
                {t('common:TRANSACTION_BATCH')}
              </Button>
            </Box>
          </Box>
          <Box className="lists-box" width="100%">
            <Typography variant="title2">{t('common:file')}</Typography>
            <FileUploader
              handleChange={setFile}
              name="file"
              label={t('common:BATCH_FILE_UPLOADER_LABEL')}
              types={['csv']}
            >
              <Paper elevation={0} variant="rootDashed" className="draggable-main draggable-small">
                <Box className="draggable-icon" />
                <Typography variant="title2">{t('common:BATCH_FILE_UPLOADER_LABEL')}</Typography>
                <Box>
                  <Typography variant="subtitle4">{t('common:or')} </Typography>
                  <Typography sx={{ textDecoration: 'underline' }} variant="subtitle4" color="secondary">
                    {t('common:browseMedia')}
                  </Typography>
                </Box>
              </Paper>
            </FileUploader>
            <Typography variant="subtitle4">{t('common:supportedMedia')}: CSV.</Typography>
            {file && (
              <Paper elevation={0} variant="colorPrimary" className="onb-file">
                <Box className="onb-file-description">
                  <Box className="color-button" sx={{ background: '#E4DDFF' }}>
                    <Typography variant="subtitle1" sx={{ color: '#7E65D5' }}>
                      CSV
                    </Typography>
                  </Box>

                  <Typography
                    variant="h6"
                    title={file.name}
                    overflow="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                    maxWidth="160px"
                  >
                    {file.name}
                  </Typography>
                </Box>
                <Box className="onb-file-icons">
                  <Button variant="outlinedBlank" onClick={() => setFile('')}>
                    <DeleteOutlineIcon />
                  </Button>
                </Box>
              </Paper>
            )}
          </Box>
        </Box>
        <Box className="lists-buttons">
          <Button size="small" variant="outlinedGrey" onClick={() => handleModalClose()}>
            {t('common:cancel')}
          </Button>
          <Button disabled={canSend()} size="small" variant="contained" type="submit" onClick={() => handleSubmit()}>
            {t('common:save')}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default ModalUpdateBatch
